import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";

const AusbildungEnglishBoundary = ({ children }) => {
  const { i18n } = useTranslation();

  useLayoutEffect(() => {
    document.documentElement.dir = "ltr";
    document.documentElement.lang = "en";
    document.body.dir = "ltr";
    document.body.style.direction = "ltr";

    if (!i18n.language?.startsWith("en")) {
      i18n.changeLanguage("en");
    }
    // Ausbildung routes own the English-only boundary. Do not restore Arabic
    // during internal navigation, which would cause an RTL flash between pages.
  }, [i18n]);

  return (
    <div dir="ltr" lang="en" style={{ direction: "ltr", textAlign: "left", minHeight: "100%" }}>
      {children}
    </div>
  );
};

export default AusbildungEnglishBoundary;
